import {
  GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_ABORTED,
  GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_REQUESTED,
  GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_COMPLETED,
  GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_FAILED,
} from '../../actions/clientwithdrawalattempts/types';

const schema = {
  error: null,
  data: { items: [] },
  gettingdata: false,
  gotdata: false,
};

export const initialState = { ...schema };

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_ABORTED:
      return {
        ...state,
        error: null,
        gettingdata: false,
      };

    case GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_REQUESTED:
      return {
        ...state,
        error: null,
        data: { items: [] },
        gettingdata: false,
      };

    case GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_COMPLETED:
      return {
        ...state,
        error: null,
        data: action.payload,
        gettingdata: false,
        gotdata: true,
      };

    case GET_CLIENTWITHDRAWALATTEMPTS_FOR_ACCOUNT_FAILED:
      return {
        ...state,
        error: action.payload,
        gettingdata: false,
      };

    default:
      return state;
  }
};

export default reducer;
